<template>
  <div>
    <b-row>
      <b-col>
        <h1>Area Utente</h1>
        <p>Questa &eacute; l'area utente...</p>
      </b-col>

      <b-col cols="4">
        <bc-newsfeed tweets="7" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import bcNewsfeed from "../../shared/NewsFeed.vue";

export default {
  name: "UserHome",
  components: {
    "bc-newsfeed": bcNewsfeed,
  },
};
</script>
